import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Leaf, Heart, Brain, Dumbbell, Apple, Moon, 
  X, ArrowRight, CheckCircle, 
  Cherry,
  Grape,
  Group,
  Users2,
  User,
  Sun,
  Mic2,
  Flame,
  Home
} from 'lucide-react';
import { Button } from "../ui/button";
import '../styles/fonts.css';

// const icons = [
//   { icon1: '⏱',
//     icon2: '💰',
//     icon3: '👨‍👩‍👧‍👦',
//     icon4: '🧘‍♀️',
//     icon5: '🌟',
//     icon6: '🍎',
//     icon7: '🏃‍♂️',
//     icon8: '🧠',
//     icon9: '🌿',
//     icon10: '👥',
//     icon11: '👨‍💼',
//     icon12: '🧑‍🎨',
//     icon13: ''
// }
// ];

const icon1 = '⏱';
const icon2 = '💰';
const icon3 = '';
const desc1 = "What's Included:";
const desc2 = "Elegibility of Service";

const services = [
  {
    id: 1,
    icon: Dumbbell,
    title: 'Restorative Therapy',
    shortDesc: 'Designed Restorative exercise programs.',
    color: 'from-emerald-500 to-teal-500',
    bgColor: 'bg-emerald-50',
    fullDesc: 'Our restorative exercise program offers a personalized, low-intensity approach that uses gentle, mindful movements to promote healing and strengthening to improve overall well-being.',
    benefits: [
      'Enhances mobility.',
      'Balance and stability exercises for those at risk for falls.',
      'Strength training to support independence in Activities of Daily Living.'
    ],
    duration: '60-90 minutes',
    price: 'From $120/session',
    ico1: icon1,
    ico2: icon2, 
    dtitile: desc1
  },
  {
    id: 2,
    icon: Mic2,
    title: 'Communication strategies and techniques',
    shortDesc: 'Helpful communication approaches for seniors who struggle with speech due to ongoing health challenges.',
    color: 'from-rose-500 to-pink-500',
    bgColor: 'bg-rose-50',
    fullDesc: 'Our communication strategies and techniques designed for seniors experiencing speech impairments caused by chronic health conditions.',
    benefits: [
      'Create a calm, supportive atmosphere',
      'Lifestyle assessment and planning',
      'Stress management techniques',
      'Ongoing support and motivation'
    ],
    duration: '45-60 minutes',
    price: 'From $95/session',
    ico1: icon1,
    ico2: icon2,
    dtitile: desc1
  },
  {
    id: 3,
    icon: Apple,
    title: 'Restorative Dining',
    shortDesc: 'Designed to help residents in care facilities maintain or regain skills related to eating and mobility during mealtimes.',
    color: 'from-purple-500 to-indigo-500',
    bgColor: 'bg-purple-50',
    fullDesc: "We focus on promoting enjoyable dining experience. ",
    benefits: [
      'Enable seniors to eat independently or with minimal assistance or supervision.',
      'Ensure safe and effective eating strategies.',
      'Esure proper nutrition and hydration.',
      'Pleasurable dining experience that will enhance social and positive emotional experience.'
    ],
    duration: '30-60 minutes',
    price: 'From $75/session',
    ico1: icon1,
    ico2: icon2,
    dtitile: desc1
  },
  {
    id: 4,
    icon: Users2,
    title: 'Companionship',
    shortDesc: 'Non-medical support service.',
    color: 'from-orange-500 to-amber-500',
    bgColor: 'bg-orange-50',
    fullDesc: 'We focus on providing meaningful social interaction and emotional support to individuals,  mostly seniors, to combat loneliness and social isolation.',
    benefits: [
      'Engagement',
      'Connection',
      'Participation in meaningful activities'
    ],
    duration: '45-60 minutes',
    price: 'From $85/session',
    ico1: icon1,
    ico2: icon2,
    dtitile: desc1
  },
  {
    id: 5,
    icon: Sun,
    title: 'Comprehensive Care Planning',
    shortDesc: "Built around the individual's personal goals and aspirations, focusing on what they can do rather than their limitations.",
    color: 'from-green-500 to-lime-500',
    bgColor: 'bg-green-50',
    fullDesc: 'Our Comprehensive Care Plan is a dynamic, person-centered strategy that uses an interdisciplinary team approach to help individuals, often older adults or those recovering from illness or injury to achieve and maintain their highest possible level of independence and functional ability. ',
    benefits: [
      'Assessments',
      'Family participation',
      'Regular progress reviews',
    ],
    duration: '60 minutes',
    price: 'From $110/session',
    ico1: icon1,
    ico2: icon2,
    dtitile: desc1
  },
  {
    id: 6,
    icon: Home,
    title: 'Fall Prevention Program',
    shortDesc: 'Physical weakness and lack of walking or gait problems are the most common causes of falls among older adults.',
    color: 'from-pink-500 to-purple-500',
    bgColor: 'bg-pink-50',
    fullDesc: 'Our Fall Prevention Program is designed to identify and mitigate fall risks through personalized interventions, education, and support, ultimately enhancing safety and quality of life for seniors. Program provides education, reduce falls, provide awareness of the risk of falls, building self-esteem and increase level of independence.',
    benefits: [
      'Maintaining a program of physical conditioning and restorative care exercises to improve strength and endurance.',
      'Use of environmental assessment and modifications to improve mobility and safety.',
      'Focus on stability and balance in performing ADL and maintaining independent lifestyle.'
    ],
    duration: '',
    price: '',
    ico1: icon3,
    ico2: icon3,
    dtitile: desc1
  },
  {
    id: 7,
    icon: Leaf,
    title: 'And much more!',
    shortDesc: 'Short or Long-term Care, We customize individual care!',
    color: 'from-blue-500 to-cyan-500',
    bgColor: 'bg-blue-50',
    fullDesc: 'Short or Long-term Care, We customize individual care!',
    benefits: [
      'Seniors in Long-term care or Retirement homes, and Community settings',
      'Seniors recovering from illness or surgery',
      'Seniors managing chronic conditions or health challenges'
    ],
    duration: '',
    price: '',
    ico1: icon3,
    ico2: icon3,
    dtitile: desc2
  },
];

export default function ServicesSection() {
  const [selectedService, setSelectedService] = useState(null);

  const scrollToContact = () => {
    setSelectedService(null);
    setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  return (
    <section id="services" className="py-24 bg-purple">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-emerald-600 font-medium text-sm uppercase tracking-wider">What We Offer</span>
          <h2 className="text-4xl md:text-5xl kaushan-script font-bold text-gray-900 mt-3 mb-6">
            Our <span className="text-emerald-600">Services</span>
          </h2>
          <p className="text-gray-600 text-lg fuzzy-bubbles max-w-2xl mx-auto">
            Comprehensive Restorative Therapy Program and Nursing Care solutions for Seniors affected by complication of aging process.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className={`group relative ${service.bgColor} rounded-2xl p-6 cursor-pointer hover:shadow-xl transition-all duration-500 border border-gray-100 overflow-hidden`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              onClick={() => setSelectedService(service)}
            >
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${service.color} opacity-10 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:scale-150 transition-transform duration-500`} />
              
              <div className={`inline-flex p-3 rounded-xl bg-gradient-to-br ${service.color} mb-4`}>
                <service.icon className="w-6 h-6 text-white" />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-gray-600 mb-4">{service.shortDesc}</p>
              
              <div className="flex items-center text-emerald-600 font-medium group-hover:gap-2 transition-all">
                <span>Learn More</span>
                <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Service Detail Modal */}
      <AnimatePresence>
        {selectedService && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedService(null)}
          >
            <motion.div
              className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className={`relative p-8 bg-gradient-to-br ${selectedService.color} text-white rounded-t-3xl`}>
                <button
                  onClick={() => setSelectedService(null)}
                  className="absolute top-4 right-4 p-2 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
                <div className="inline-flex p-4 rounded-2xl bg-white/20 mb-4">
                  <selectedService.icon className="w-8 h-8" />
                </div>
                <h3 className="text-3xl font-bold mb-2">{selectedService.title}</h3>
                {/* <div className="flex flex-wrap gap-4 text-white/90 text-sm"> */}
                  {/* <span>⏱ {selectedService.duration}</span> */}
                  {/* <span>💰 {selectedService.price}</span> */}
                   {/* <span>{selectedService.ico1} {selectedService.duration}</span> */}
                  {/* <span>{selectedService.ico2} {selectedService.price}</span> */}
                {/* </div> */}
              </div>

              {/* Modal Content */}
              <div className="p-8">
                <p className="text-gray-600 text-lg leading-relaxed mb-6">
                  {selectedService.fullDesc}
                </p>

                <h4 className="font-semibold text-gray-900 mb-4"> <span>{selectedService.dtitile} </span></h4>
                <ul className="space-y-3 mb-8">
                  {selectedService.benefits.map((benefit, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-600">{benefit}</span>
                    </li>
                  ))}
                </ul>

                <div className="flex flex-col sm:flex-row gap-4">
                  <Button
                    onClick={scrollToContact}
                    className={`flex-1 h-12 bg-gradient-to-r ${selectedService.color} hover:opacity-90 text-white font-semibold rounded-xl`}
                  >
                    Book a Consultation
                  </Button>
                  <Button
                    variant="outline"
                    onClick={() => setSelectedService(null)}
                    className="flex-1 h-12 rounded-xl"
                  >
                    Close
                  </Button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}